import { cn } from "@/lib/utils";

export type Lang = "tr" | "en";

export function LangToggle({ value, onChange }: { value: Lang; onChange: (l: Lang) => void }) {
  return (
    <div className="inline-flex items-center rounded-md border border-input bg-background p-0.5">
      {(["tr", "en"] as const).map((lang) => (
        <button
          key={lang}
          type="button"
          onClick={() => onChange(lang)}
          className={cn(
            "rounded px-3 py-1 text-xs font-semibold uppercase transition-colors",
            value === lang
              ? "bg-primary text-primary-foreground"
              : "text-muted-foreground hover:text-foreground",
          )}
        >
          {lang}
        </button>
      ))}
    </div>
  );
}
